import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { HttpService } from '../services/http.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { URLUtils } from '../urlUtils';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPlanComponent } from 'src/app/confirm-plan/confirm-plan.component';

@Component({
    selector: 'audit-trails',
    templateUrl: 'audit-trails.component.html',
    styleUrls: ['audit-trails.component.scss'],
    standalone: false
})
export class AuditTrailsComponent {
    product = environment.product;
    p: any=1;
    members: any = [];
    membersList: any[] = [];
    searchText: any = "";
    ghname: string = "";
    logForm: any = FormGroup;
    submitted: boolean = false;
    pipe = new DatePipe('en-US');
    loglist: any[] = [];
    data: any = {};
    auditLogs: any;
    filterByCategory: any;
    isChecked: boolean = false;  // Boolean flag
    term: any;
    fromCount: any = 1;
    toCount: any = 10;
    isReverse: boolean = false;
    frombsValue: any;
    tobsValue: any;
    selectedCategory: string | null = null;
    getcat:any;

    itemsPerPage = 10;
    totalPages = 0;
    paginatedData: any[] = [];

    isAdvancedSearch: boolean = false;
    // fromDate: string = '';
    // toDate: string = '';
    fromDate: any;
    toDate: any;

    minDate: any;
    maxDate: any;
    // Datepicker Config
    datePickerConfig = {
    dateInputFormat: 'MMM DD, YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-default'
    };
    bsValue: any;

    //for Lauditor, Content, Connect
    // categoryList: any = [
    //     { name: 'Authorization', value: 'AUTH' },
    //     { name: 'Groups', value: 'GROUPS' },
    //     { name: 'Team Members', value: "TEAM MEMBER" },
    //     { name: 'Relationships', value: 'RELATIONSHIP' },
    //     { name: 'Relationships Invite', value: 'RELATIONSHIP INVITE' },
    //     { name: 'Share', value: "SHARE" },
    //     { name: 'Documents', value: 'DOCUMENT' },
    //     {name: 'Timesheets', value: 'TIMESHEETS' },
    //     {name: 'Invoices', value: 'INVOICE' },
    //     { name: 'Merge PDF', value: 'MERGE PDF' },
    //     { name: 'Legal Matters', value: 'LEGAL MATTER' },
    //     { name: 'General Matters', value: 'GENERAL MATTER' },
    //     //{ name: 'Matters', value: 'MATTERS' },
    //     // { name: 'Timesheets', value: '' }
    // ]
    categoryList: any[] = [];

    categoryListAAM: any = [
        { name: 'Authorization', value: 'AUTH' },
        { name: 'Groups', value: 'GROUPS' },
        { name: 'Team Members', value: "TEAM MEMBER" },
    ]

    //for Corporate only
    categoryCorp: any = [
        { name: 'Authorization', value: 'AUTH' },
        { name: 'Departments', value: 'DEPARTMENTS' },
        { name: 'Team Members', value: "TEAM MEMBER" },
        { name: 'Relationships', value: 'RELATIONSHIP' },
        { name: 'Share', value: "SHARE" },
        { name: 'Documents', value: 'DOCUMENT' },
        // {name: 'Timesheets', value: 'TIMESHEETS' },
        // {name: 'Invoices', value: 'INVOICE' },
        { name: 'Merge PDF', value: 'MERGE PDF' },
        { name: 'Legal Matters', value: 'LEGAL MATTER' },
        { name: 'General Matters', value: 'GENERAL MATTER' },
        // { name: 'Timesheets', value: '' }
    ]

    //for Content GH-role only
    categoryContGH: any = [
        { name: 'Authorization', value: 'AUTH' },
        { name: 'Groups', value: 'GROUPS' },
        { name: 'Team Members', value: "TEAM MEMBER" },
        { name: 'Relationships', value: 'RELATIONSHIP' },
        { name: 'Share', value: "SHARE" },
        { name: 'Documents', value: 'DOCUMENT' },
        // {name: 'Timesheets', value: 'TIMESHEETS' },
        // {name: 'Invoices', value: 'INVOICE' },
        { name: 'Merge PDF', value: 'MERGE PDF' }
    ]

    //for Connect GH-role only
    categoryConnectGH: any = [
        { name: 'Authorization', value: 'AUTH' },
        { name: 'Groups', value: 'GROUPS' },
        { name: 'Team Members', value: "TEAM MEMBER" },
        { name: 'Relationships', value: 'RELATIONSHIP' },
        { name: 'Share', value: "SHARE" },
        { name: 'Documents', value: 'DOCUMENT' }
        // {name: 'Timesheets', value: 'TIMESHEETS' },
        // {name: 'Invoices', value: 'INVOICE' },
    ]
    name: string = "";
    roleId: string = "GH";
    role: string = "GH";
    catsolo:any;
      
    getPlan:any;
    restrictedPlans = ['free', 'professional', 'starter'];

    constructor(private httpService: HttpService,private dialog: MatDialog,
        private fb: FormBuilder, private spinnerService: NgxSpinnerService,
        private router: Router) {
        this.filterByCategory = [];
    }

    ngOnInit(): void {
        this.catsolo = localStorage.getItem('category');
        this.getPlan = localStorage.getItem("plan"); // get current plan

        this.categoryList = [
            { name: 'Authorization', value: 'AUTH' },
            { name: 'Documents', value: 'DOCUMENT' },
            { name: 'General Matters', value: 'GENERAL MATTER' },
            ...(this.catsolo !== 'solo' ? [{ name: 'Groups', value: 'GROUPS' }] : []),
            { name: 'Invoices', value: 'INVOICE' },
            { name: 'Legal Matters', value: 'LEGAL MATTER' },
            // { name: 'Merge PDF', value: 'MERGE PDF' },
            { name: 'Relationships', value: 'RELATIONSHIP' },
            { name: 'Appointments', value: 'APPOINTMENTS' },
            { name: 'Relationships Invite', value: 'RELATIONSHIP INVITE' },
            { name: 'Share', value: 'SHARE' },
            ...(this.catsolo !== 'solo' ? [{ name: 'Team Members', value: 'TEAM MEMBER' }] : []),
            { name: 'Timesheets', value: 'TIMESHEETS' },
        ];

  
        this.logForm = this.fb.group({
            // category: ['Authorization', Validators.required],
            // client: ['', Validators.required],
            // tm: ['', Validators.required],
            // search: [''],
            fromDate: [''],
            toDate: ['']
        });
        //console.log(this.categoryList)
        this.getAuditList();

        this.bsValue = new Date();

        var role = localStorage.getItem("role")
        if (role != null) { this.roleId = role }
        if (role == 'SU') { this.role = 'SuperUser' }
        if (role == 'AAM') { this.role = 'Admin' }
        if (role == 'TM') { this.role = 'Team Member' }
        if (role == 'GH') { this.role = 'Group Head' }
    }

    selectCategory(item: { value: string; name: string }) {
        this.selectedCategory = item.name;
        this.getCategory(item.value);
    }

    isCheckBox(val: any) {
        this.isChecked = val;
        if (!val) {
            this.frombsValue = null;
            this.tobsValue = null;
            this.logForm.reset();
            this.filterByCategory = [...this.auditLogs];
            this.p = 1;
            this.pageChanged(1);
            this.selectedData();
        }
    }
    get f() { return this.logForm.controls; }

    close() {
    }

    onSubmit() {
        let data = this.logForm.value
        data['fromDate'] = this.pipe.transform(data['fromDate'], 'dd-MM-yyyy');
        data['toDate'] = this.pipe.transform(data['toDate'], 'dd-MM-yyyy');
        this.httpService.sendPutRequest(URLUtils.getAudit, data).subscribe(
            (res: any) => {
                this.filterByCategory = res['data']
            })
    }
    getAuditList() {
        this.spinnerService.show();
        this.httpService.sendGetRequest(URLUtils.getAudit).subscribe(
            (res: any) => { 
                this.auditLogs = res.data;
                //this.filterByCategory = this.auditLogs;
                // this.filterByCategory = this.auditLogs.filter((log: any) => log.name.trim() !== 'MATTER');
                //console.log('Filtered Data:', this.filterByCategory);
                // Use timeout to avoid UI blocking
                setTimeout(() => {
                    this.filterByCategory = this.auditLogs.filter((log: any) => log.name.trim() !== 'MATTER');
                    this.p = 1;
                    this.updatePagination();
                    this.spinnerService.hide();
                }, 0);
            });

    }
   
    //subscription check for action button
    checkPlan(event?: MouseEvent): boolean {
        const restrictedPlans = ['free', 'professional', 'starter'];

        if (restrictedPlans.includes(this.getPlan)) {
            this.dialog.open(ConfirmPlanComponent, {
                width: '400px',
                data: { plan: this.getPlan }
            });

            return false;   // Stop further execution
        }
        return true;      // Allow further execution
    }

    getCategory(val: any) {
        //console.log('val',val)
        if (!this.checkPlan()) {
            return;
        } // Stop here if plan is restricted

        this.getcat=val.value
        let filterByCategory: any = [];
        this.selectedCategory = val.name;
        //console.log('selectedCategory', this.selectedCategory);
        this.auditLogs.forEach((item: any) => {
            if (item.name == val.value) {
                filterByCategory.push(item);
            }
        });

        this.filterByCategory = filterByCategory;
        this.p=1;
        this.updatePagination();
        this.pageChanged(1);
        this.selectedData(); 
        this.applyFilters();
    }
     pageChanged(val: any) {
         this.fromCount = (val * 10) - 9;
         this.toCount = val * 10;
         //console.log("page change " + val);
     }
    // getCurrent(val: any) {
    //     //console.log("current page change " + val);
    // }
    sortDocuments(val: any) {
        this.isReverse = !this.isReverse;
        if (this.isReverse) {
            this.filterByCategory = this.filterByCategory?.sort((p1: any, p2: any) => (p1[val] < p2[val]) ? 1 : (p1[val] > p2[val]) ? -1 : 0);
        } else {
            this.filterByCategory = this.filterByCategory?.sort((p1: any, p2: any) => (p1[val] > p2[val]) ? 1 : (p1[val] < p2[val]) ? -1 : 0);
        }
    }
    selectFromDuration(val: any) {
        this.frombsValue = val;
        this.selectedData();
    }
    selectToDuration(val: any) {
        this.tobsValue = val;
        this.selectedData();
    }
    // selectedData(){
    //     let timeFilter: any = [];
    //     if (this.frombsValue && this.tobsValue) {
    //         this.filterByCategory.forEach((item: any) => {
    //             if (new Date(item.timestamp) >= this.frombsValue && new Date(item.timestamp) <= this.tobsValue) {
    //                 timeFilter.push(item)
    //             }
    //         })
    //         this.filterByCategory = timeFilter;
    //         this.pageChanged(1);
    //         this.p=1;
    //     }
    // }

    selectedData() {
        let timeFilter: any = [];
        
        // get filter by category (getcat)
        this.auditLogs.forEach((item: any) => {
            if (item.name === this.getcat) {
                timeFilter.push(item);
            }
        });
    
        if (this.frombsValue && this.tobsValue) {
            const fromDate = new Date(this.frombsValue);
            const toDate = new Date(this.tobsValue);

            timeFilter = timeFilter.filter((item: any) => {
                const logDate = new Date(item.timestamp); // Convert the timestamp to a Date object
                return logDate >= fromDate && logDate <= toDate;
            });
        }
    
        // Update filterByCategory with final filters
        this.filterByCategory = timeFilter;
        //console.log('Filtered Logs:', this.filterByCategory);
        this.p = 1; // Reset pagination
        this.pageChanged(1);
    }
    
    ngAfterViewInit() {

    }
    updatePagination() {
        this.totalPages = Math.ceil(this.filterByCategory.length / this.itemsPerPage);

        const startIndex = (this.p - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;

        this.paginatedData = this.filterByCategory.slice(startIndex, endIndex);

        this.fromCount = this.filterByCategory.length ? startIndex + 1 : 0;
        this.toCount = endIndex > this.filterByCategory.length
            ? this.filterByCategory.length
            : endIndex;
    }
    next() {
        if (this.p < this.totalPages) {
            this.p++;
            this.updatePagination();
        }
    }

    prev() {
        if (this.p > 1) {
            this.p--;
            this.updatePagination();
        }
    }

    onFromDateChange(date: Date) {
        this.fromDate = date;

        if (this.toDate && this.toDate < this.fromDate) {
            this.toDate = null;
        }
        this.applyFilters();
    }

    onToDateChange(date: Date) {
        this.toDate = date;
        this.applyFilters();
    }

    applyFilters() {
        let filtered = [...this.auditLogs];

        // ✅ CATEGORY FILTER
        if (this.getcat) {
            filtered = filtered.filter(log => log.name === this.getcat);
        }

        // ✅ SEARCH FILTER
        if (this.term && this.term.trim() !== '') {
            const search = this.term.toLowerCase();

            filtered = filtered.filter(log =>
                (log.name && log.name.toLowerCase().includes(search)) ||
                (log.message && log.message.toLowerCase().includes(search))
            );
        }

        // DATE FILTER (ONLY IF ADVANCED SEARCH IS ON)
        if (this.isAdvancedSearch) {

            if (this.fromDate) {
                const from = new Date(this.fromDate);
                from.setHours(0, 0, 0, 0);

                filtered = filtered.filter(log => {
                    const logDate = new Date(log.timestamp);
                    return logDate >= from;
                });
            }

            if (this.toDate) {
                const to = new Date(this.toDate);
                to.setHours(23, 59, 59, 999);

                filtered = filtered.filter(log => {
                    const logDate = new Date(log.timestamp);
                    return logDate <= to;
                });
            }
        }

        // UPDATE FINAL DATA
        this.filterByCategory = filtered;

        // Reset pagination
        this.p = 1;
        this.updatePagination();
    }

    onAdvancedToggle() {
        if (!this.isAdvancedSearch) {
            this.fromDate = null;
            this.toDate = null;
        }

        this.applyFilters();
    }

}

